export const getAbsoluteUrl = (url) => {
    if (!url)
        return undefined;
    if (process.env.REACT_APP_SERVER_HOST) {
        return new URL(url, process.env.REACT_APP_SERVER_HOST);
    }
    return new URL(url, document.baseURI);
};
//# sourceMappingURL=URL.js.map